import { fromJS } from 'immutable';

import {
	FETCH_ADMIN_ROIS,
	FETCH_ADMIN_ROIS_SUCCESS,
	FETCH_ADMIN_ROIS_ERROR,
	ADMIN_LINK_ROI,
	ADMIN_LINK_ROI_SUCCESS,
	ADMIN_LINK_ROI_ERROR,
	ADMIN_REVOKE_ROI,
	ADMIN_REVOKE_ROI_SUCCESS,
	ADMIN_REVOKE_ROI_ERROR,
	APPROVE_ROI_MATCH,
	APPROVE_ROI_MATCH_SUCCESS,
	APPROVE_ROI_MATCH_ERROR,
	REJECT_ROI_MATCHES,
	REJECT_ROI_MATCHES_SUCCESS,
	REJECT_ROI_MATCHES_ERROR,
} from './constants';

export const initialState = fromJS({
	rois: [],
	total: 0,
	page: 1,
	limit: 20,
	loading: false,
	submitting: false,
	error: null,
});

function adminRoiListReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_ADMIN_ROIS:
			return state.set('loading', true).set('error', null);
		case FETCH_ADMIN_ROIS_SUCCESS:
			return state
				.set('rois', fromJS(action.data.rois || []))
				.set('total', action.data.total || 0)
				.set('page', action.data.page || 1)
				.set('limit', action.data.limit || 20)
				.set('loading', false);
		case FETCH_ADMIN_ROIS_ERROR:
			return state.set('error', action.err).set('loading', false);

		case ADMIN_LINK_ROI:
		case ADMIN_REVOKE_ROI:
		case APPROVE_ROI_MATCH:
		case REJECT_ROI_MATCHES:
			return state.set('submitting', true).set('error', null);
		case ADMIN_LINK_ROI_SUCCESS:
		case ADMIN_REVOKE_ROI_SUCCESS:
		case APPROVE_ROI_MATCH_SUCCESS:
		case REJECT_ROI_MATCHES_SUCCESS:
			return state.set('submitting', false);
		case ADMIN_LINK_ROI_ERROR:
		case ADMIN_REVOKE_ROI_ERROR:
		case APPROVE_ROI_MATCH_ERROR:
		case REJECT_ROI_MATCHES_ERROR:
			return state.set('error', action.err).set('submitting', false);

		default:
			return state;
	}
}

export default adminRoiListReducer;
